import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b8a1da72"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "tw-sticky tw-top-0 tw-z-[1]" }
const _hoisted_3 = {
  key: 0,
  class: "!tw-w-[1px] table-header"
}
const _hoisted_4 = {
  key: 1,
  class: "tw-min-w-[37px] !tw-mr-[22px] tw-py-3 tw-px-4 tw-text-sm tw-text-gray-700 table-header"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "tw-w-[max-content]" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["onMouseover"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick", "innerHTML"]
const _hoisted_12 = {
  key: 0,
  class: "detail"
}
const _hoisted_13 = ["colspan"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "tr-empty" }
const _hoisted_16 = ["colspan"]
const _hoisted_17 = { class: "tw-w-full tw-text-[#878787] tw-text-[14px] tw-text-center" }
const _hoisted_18 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_custom_check_box = _resolveComponent("custom-check-box")!
  const _component_SwapIcon = _resolveComponent("SwapIcon")!
  const _component_DraggableIcon = _resolveComponent("DraggableIcon")!
  const _component_TableSkeleton = _resolveComponent("TableSkeleton")!

  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.id,
    class: _normalizeClass(`shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] rounded-md border-solid border-[#EFF0F1] tw-max-h-[100%] tw-overflow-auto tableWrapper ${_ctx.customClass}`)
  }, [
    _createElementVNode("table", {
      class: _normalizeClass(`tw-min-w-full tw-divide-y tw-divide-gray-200 table ${
        _ctx.isStandardRow ? 'table-default' : ''
      }`)
    }, [
      _createElementVNode("thead", _hoisted_2, [
        _createElementVNode("tr", {
          class: _normalizeClass(`tw-bg-[#FFF] tw-h-[44px] table-row !tw-border-0 ${_ctx.headerWrapperClass}`)
        }, [
          (_ctx.draggable)
            ? (_openBlock(), _createElementBlock("th", _hoisted_3))
            : _createCommentVNode("", true),
          (_ctx.showCheckboxRow)
            ? (_openBlock(), _createElementBlock("th", _hoisted_4, [
                _createVNode(_component_custom_check_box, {
                  class: _normalizeClass(`tw-h-[20px] !tw-mb-0 ${_ctx.draggable ? '!tw-pl-0' : ''}`),
                  size: "20px",
                  "color-checkmark": _ctx.colorCheckmark,
                  "is-checked": _ctx.selectAll,
                  "onUpdate:isChecked": _cache[0] || (_cache[0] = (value) => _ctx.onSelectAllChanged(value))
                }, null, 8, ["class", "color-checkmark", "is-checked"])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, index) => {
            return (_openBlock(), _createElementBlock("th", {
              key: column.value,
              class: _normalizeClass(`tw-py-3 tw-px-4 tw-text-sm tw-text-gray-700 table-header tw-pr-10 ${
              index === 1 ? 'th-two' : ''
            }`)
            }, [
              _createElementVNode("span", {
                class: _normalizeClass([
                `tw-flex tw-item-center tw-gap-[4px] tw-select-none tw-items-center`,
                column.headerClass ? column.headerClass : '',
                column.sortable ? 'tw-cursor-pointer' : '',
                _ctx.columnActive === index
                  ? `!tw-text-[${_ctx.textHeaderSortActiveDefault}]`
                  : `!tw-text-[${_ctx.textHeaderDefault}]`,
              ]),
                onClick: ($event: any) => (_ctx.clickSortHeader(column, index))
              }, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(column.text), 1),
                (column.sortable)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                      _createVNode(_component_SwapIcon, {
                        color: 
                    _ctx.columnActive === index
                      ? _ctx.textHeaderSortActiveDefault
                      : _ctx.textHeaderDefault
                  
                      }, null, 8, ["color"])
                    ]))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_5)
            ], 2))
          }), 128))
        ], 2)
      ]),
      (!_ctx.isLoading && _ctx.data?.length)
        ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedData, (item, idx) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: `${_ctx.dataType}-${item.id}`
              }, [
                _createElementVNode("tr", {
                  class: _normalizeClass(`table-row ${
              item.id === _ctx.idItemExpland ? 'row-expaned' : ''
            } ${
              _ctx.isStandardRow && _ctx.selectedRows.includes(item.id)
                ? 'selected-row'
                : ''
            }`),
                  style: _normalizeStyle(`background-color: ${
              _ctx.selectedRows.includes(item.id) ? '#F2F8FF' : item.rowBgColor || ''
            }`),
                  onMouseover: ($event: any) => (_ctx.hoveringRowId = item.id),
                  onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hoveringRowId = ''))
                }, [
                  (_ctx.draggable)
                    ? (_openBlock(), _createElementBlock("td", {
                        key: 0,
                        class: _normalizeClass(`tw-w-[18px] table-data tw-cursor-pointer !tw-pr-[10px] !tw-pb-[20px] ${
                _ctx.heightTb ? ' tw-h-[56px] table__data' : 'tw-h-[64px]'
              }`)
                      }, [
                        _createVNode(_component_DraggableIcon)
                      ], 2))
                    : _createCommentVNode("", true),
                  (_ctx.showCheckboxRow)
                    ? (_openBlock(), _createElementBlock("td", {
                        key: 1,
                        class: _normalizeClass(`!tw-w-[30px] tw-py-3 tw-px-4 tw-text-sm tw-text-gray-700 table-data tw-h-[64px] ${
                _ctx.heightTb ? ' tw-h-[56px] table__data' : 'tw-h-[64px]'
              } ${_ctx.isShowHoverBg(item.id) ? _ctx.hoverBgColor : ''} ${
                item?.checklistGroupCompletionPcnt === 1
                  ? '!tw-bg-[#EFF0F180]'
                  : ''
              } ${
                _ctx.idItemExpland === item.id || _ctx.selectedRows.includes(item.id)
                  ? _ctx.extendActiveBgColor
                  : ''
              }`)
                      }, [
                        _createVNode(_component_custom_check_box, {
                          id: item.id,
                          class: "!tw-mb-0 tw-h-[20px] !tw-pl-0",
                          size: "20px",
                          "color-checkmark": _ctx.colorCheckmark,
                          "is-checked": _ctx.selectedRows.includes(item.id),
                          "onUpdate:isChecked": () => _ctx.toggleRow(item.id, item)
                        }, null, 8, ["id", "color-checkmark", "is-checked", "onUpdate:isChecked"])
                      ], 2))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
                    return (_openBlock(), _createElementBlock("td", {
                      key: column.value,
                      class: _normalizeClass(`tw-py-3 tw-px-4 ${
                column.font13 ? 'tw-text-[13px]' : 'tw-text-[14px]'
              } ${column.textAlign ? 'table__data' : ''}   
                tw-text-gray-700 ${
                  column.valueClass ? column.valueClass : ''
                } table-data  ${_ctx.isShowHoverBg(item.id) ? _ctx.hoverBgColor : ''} ${
                  item?.checklistGroupCompletionPcnt === 1
                    ? '!tw-bg-[#EFF0F180]'
                    : ''
                } ${
                  _ctx.idItemExpland === item.id || _ctx.selectedRows.includes(item.id)
                    ? _ctx.extendActiveBgColor
                    : ''
                }`),
                      onClick: ($event: any) => (_ctx.onClickItem(item, column))
                    }, [
                      _renderSlot(_ctx.$slots, 'cell(' + column.value + ')', {
                        value: item[column.value],
                        idx: idx,
                        item: item
                      }, () => [
                        (typeof column.render === 'function')
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "tw-flex tw-w-[max-content]",
                              onClick: ($event: any) => (_ctx.getAttachment(item)),
                              innerHTML: 
                      _ctx.getSafeHTML(
                        column.value === '*'
                          ? column.render(item)
                          : column.render(item[column.value]),
                      )
                    
                            }, null, 8, _hoisted_11))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(item[column.value]), 1)
                            ], 64))
                      ], true)
                    ], 10, _hoisted_10))
                  }), 128))
                ], 46, _hoisted_9),
                (item.id === _ctx.idItemExpland)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                      _createElementVNode("td", {
                        colspan: _ctx.columns.length + 2,
                        class: "detail_content"
                      }, [
                        _renderSlot(_ctx.$slots, 'detail', {
                          item: item,
                          value: item.id === _ctx.idItemExpland
                        }, undefined, true)
                      ], 8, _hoisted_13)
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isLoading && !_ctx.data?.length)
        ? (_openBlock(), _createElementBlock("tbody", _hoisted_14, [
            _createElementVNode("tr", _hoisted_15, [
              _createElementVNode("td", {
                colspan: _ctx.showCheckboxRow ? _ctx.columns.length + 1 : _ctx.columns.length
              }, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.emptyText || ""), 1)
                ])
              ], 8, _hoisted_16)
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("tbody", _hoisted_18, [
            _createVNode(_component_TableSkeleton, {
              "rows-number": _ctx.skeletonRowNumber,
              "columns-number": 
            _ctx.columns.length + (_ctx.draggable ? 1 : 0) + (_ctx.showCheckboxRow ? 1 : 0)
          
            }, null, 8, ["rows-number", "columns-number"])
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ], 10, _hoisted_1))
}